<template>
    <div id="contents" >
        <div class="wrap">
            <div class="header">
                <div class="container container-fluid rm-l-p rm-r-p">
                    <div class="pull-left col-md-3 header-left">
                        <a href="/"><img src="../assets/img/logo.png" alt="一路牛" class="header-logo-pc" width="48"
                                         draggable="false"></a>
                        <a href="/"><img src="../assets/img/logo.png" alt="一路牛" width="40" height="40" class="header-logo-m"
                                         draggable="false"></a>
                    </div>
                    <div class="pull-right col-md-9 header-right">
                        <div class="header-main">
                            <div class="pull-left header-middle">
                                <ul class="header-nav pull-left clearfix" style="display: none">
                                </ul>
                            </div>
                        <user-list/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu-ctrl">
                <span class="menu-ctrl-line menu-ctrl-line-t"></span>
                <span class="menu-ctrl-line menu-ctrl-line-m"></span>
                <span class="menu-ctrl-line menu-ctrl-line-b"></span>
            </div>
            <div class="wrap-index text-center">
                <h1 class="slogan fzlt">使物流配货站数据化、一体式管理</h1>
                <div class="text">通过使用一路牛配货管理系统，可以将配货单、司机、车辆
                    <br>和销售额等数据一体式进行管理
                </div>
                <div class="first-sc-link">
                  <router-link to="/dashboard">
                    <a class="btn btn-org-full btn-more">立即体验</a>
                  </router-link>
                  <router-link to="/register">
                  <a class="register-link">立即注册</a>
                  </router-link>
                </div>
            </div>
            <img src="../assets/img/applet.png" alt="微信小程序" class="applet">
            <img src="../assets/img/box-shadow-1e67360000.png" alt="" class="box-shadow" draggable="false">
        </div>
        <div class="featrue">

        </div>
        <div>
            <div class="featrue container featrue-contact">
                <div class="contact text-center">
                    <div class="title fzlt">使用一路牛配货管理系统的配货站已有</div>
                    <span class="count">
                         <ol class="total"><li class="count-details">3</li><li class="count-details">9</li><span
                                 class="quote">,</span><li class="count-details">1</li><li class="count-details">5</li><li
                                 class="count-details">4</li></ol>
                    </span>
                    <a target="_blank" href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101414348&redirect_uri=http://lzw188.com/qqLogin/qq&state=qq" class="btn btn-org-full sale">了解产品</a>
                    <br>
                    <a href="javascript:void(0)" class="register-link">联系销售</a>
                </div>
            </div>
        </div>
        <template id="tmpl"></template>
        <!--<div class="chat-online">-->
            <!--<a class="btn btn-org-full chat-online-btn" href="javascript:void(0)" target="_blank">在线客服</a>-->
        <!--</div>-->
        <div class="footer">
            <div class="container rm-l-p rm-r-p">
                <div class="index-footer">
                    <div class="col-xs-12 rm-l-p rm-r-p index-footer-section">
                        <div class="footer-nav clearfix">
                            <div class="footer-wd-icon ldms-font ldms-yiluniu"></div>
                            <div class="left">
                                <dl class="clearfix">
                                    <dt>产品</dt>
                                    <dd>
                                        <a href="javascript:void(0)">LDMS</a>
                                    </dd>
                                </dl>
                                <dl class="clearfix">
                                    <dt>开发资源</dt>
                                    <dd>
                                        <a href="javascript:void(0)">使用文档</a>
                                    </dd>
                                </dl>
                                <dl class="clearfix">
                                    <dt>公司</dt>
                                    <dd><a href="javascript:void(0)">关于我们</a></dd>
                                </dl>
                            </div>
                            <div class="right">
                                <dl class="clearfix">
                                    <dt>客户中心</dt>
                                    <dd class="service-mail">客服邮箱：<a href="javascript:void(0)">javacream@163.com</a></dd>
                                    <dd class="daike qq">
                                        <a href="javascript:void(0)" style="position: relative" target="_blank">客服电话:15561422927</a>
                                    </dd>
                                    <div class="link-icons">
                                        <dd class="link-icon link-icon-weixin">
                                            <span class="ldms-font ldms-weixin1 icon-font"></span>
                                            <img id="weixin-code" src="../assets/img/weixin.jpeg" alt="微信二维码" width="150"
                                                 height="150" draggable="false">
                                        </dd>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-info clearfix">
                <div class="wd-footer-logo"><img src="../assets/img/foot.png" alt="" draggable="false"></div>
                <div class="container">
                    <div class="pull-left">
                    <span class="police-copy">
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=3605n.jianhua.1997523009.43.5af911d9RPa3tU&recordcode=15020302000151" target="_blank" class="copyright-link">
                            <img src="../assets/img/copy-d7b554ce51.png" class="police-logo" width="14" height="14"
                                 alt="" draggable="false">
                        </a>\
                    </span>
                      <span class="police-copy">
                        <a href="http://beian.miit.gov.cn/?token=ec75d9bd-94a8-453a-86ee-4b7a283f4d73" target="_blank" >
                          <span class="icp">浙ICP备16040125号-1</span>
                        </a>
                      </span>
                    </div>
                    <div class="pull-right">
                    <span class="wilddog-service">
                        <a href="javascript:void(0)"><span class="wilddog-service-text">服务协议</span></a>
                    </span>
                        <span class="wilddog-copy">© 一路牛 <span id="data">2018</span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userList from './layout/userList'

export default {
  name: 'index',
  components: {
    userList
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../assets/css/ui.css';
@import '../assets/css/index.css';
.chat-online
  position: fixed
  bottom: -1px
  right: 50px
  z-index: 9
.chat-online
  .chat-online-btn
    border: none
    width: 240px
    height: 43px
    line-height: 43px
    text-align: left
    font-size: 15px
    padding-left: 19px
    border-bottom-right-radius: 0
    border-bottom-left-radius: 0
    background-repeat: no-repeat
    background-position: 203px center
.applet{
  width :400px;
  height 114px;
  border: 1px solid white;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
[v-cloak]
  display: none
</style>
